<script lang="ts">
import { LoadSource } from "@src/jit/JIT";

import { onDestroy, onMount } from "svelte";

import Main from "./Main.svelte";


function handleMessage(e: MessageEvent) {
    LoadSource(e.data);
}

onMount(() => {
    window.addEventListener('message', handleMessage);
});

onDestroy(() => {
    window.removeEventListener('message', handleMessage);
})

</script>

<Main />

